import { Organisation } from '@/features'
import React, { memo } from 'react'
import { View, Text } from '@/components'
import { Theme, variantProvider } from '@/app'
import { PerTopicEngagementScore, ReviewButtons } from './OrgPageComponents'

export type OrgDesktopPageProps = {
  organisation: Organisation.T.Organisation
}

const OrgDesktopPageComponent = (props: OrgDesktopPageProps) => {
  const { organisation } = props

  const isBlurred = organisation.hide_scores

  return (
    <View variants={['fullWidth', 'gap:5', 'marginBottom:5']}>
      <View style={styles.wrapper}>
        <View
          variants={['column', 'gap:5', 'alignSelfStart']}
          css={styles.leftWrapper}
        >
          <View
            style={Theme.effects.light}
            variants={[
              'column',
              'gap:1.5',
              'fullWidth',
              'padding:4',
              'backgroundColor:neutral1',
              'border-radius:large',
            ]}
          >
            <Text text={'Hurd Score'} variants={['h2', 'bold']} />

            <PerTopicEngagementScore
              organisation={organisation}
              blurred={isBlurred}
            />

            <ReviewButtons organisation={organisation} />
          </View>

          {/* {hasNps ? <NPS organisation={organisation}/> : null} */}

          <Organisation.OrganisationDetails
            text={organisation?.details}
            title={organisation?.name}
            image={organisation?.logo}
          />
        </View>
        <View variants={['flex']}>
          <Organisation.EmployeeReviews
            organisation={organisation}
            blurred={isBlurred}
          />
        </View>
      </View>
    </View>
  )
}

const styles = variantProvider.createComponentStyle(
  theme => ({
    wrapper: {
      display: 'flex',
      flex: 1,
      gap: theme.spacing.value(5),
      ...theme.presets.fullWidth,
    },
    leftWrapper: {
      [theme.media.up('mid')]: {
        position: 'sticky',
        top: theme.spacing.value(2),
        left: 0,
        zIndex: 1,
        alignSelf: 'flex-start',
        width: '41%',
      },
    },
  }),
  true
)

export const OrgDesktopPage = memo(OrgDesktopPageComponent as React.FC)
